export function initCheckboxFilter() {
  // Selectors
  const chosenContainerSelector = "[data-choosed-container]";
  const checkboxSelector = "[data-checkbox-filter]";
  const textContentSelector = "[data-text-content]";
  const textContentCssClass = "choosed-item-results__text-content";
  const removeButtonSelector = "[data-remove-button]";
  const removeButtonCssClass = "choosed-item-results__remove";
  const choosedItemSelector = "[data-choosed-item]";
  const choosedItemCssClass = "choosed-item-results";

  const removeButtonTemplate = `
        <div class="${removeButtonCssClass}" data-remove-button>
            <svg width="12" height="12">
                <use xlink:href="${WPJS.themeUrl}/dist/img/icons/icons.svg#close"></use>
            </svg>
        </div>
    `;

  // Main Element
  const chosenContainer = document.querySelector(chosenContainerSelector);

  if (!chosenContainer) {
    return;
  }

  /**
   * Creates an element with the selected filter.
   * @param {string} id - checkbox ID.
   * @param {string} html - HTML from the checkbox.
   */
  function createChoosedItem(id, html) {
    const choosedItem = document.createElement("div");
    choosedItem.setAttribute("data-choosed-item", "");
    choosedItem.setAttribute("data-checkbox-id", id);
    choosedItem.classList.add(choosedItemCssClass);
    choosedItem.innerHTML = `
            <div data-text-content class="${textContentCssClass}">
                ${html}
            </div>
            ${removeButtonTemplate}
        `;
    chosenContainer.appendChild(choosedItem);
  }

  /**
   * Removes item from selected filters by checkbox ID.
   * @param {string} id - checkbox ID.
   */
  function removeChoosedItemById(id) {
    const choosedItem = chosenContainer.querySelector(
      `[data-checkbox-id="${id}"]`
    );
    if (choosedItem) choosedItem.remove();
  }

  /**
   * Handles checkbox state change.
   * @param {HTMLInputElement} checkbox - Changed checkbox.
   */
  function handleCheckboxChange(checkbox) {
    const checkboxLabel = checkbox
      .closest(".checkbox")
      .querySelector(".checkbox__text");
    if (checkbox.checked) {
      createChoosedItem(checkbox.id, checkboxLabel.innerHTML);
    } else {
      removeChoosedItemById(checkbox.id);
    }
  }

  /**
   * Handles deletion of the selected element.
   * @param {HTMLElement} target - Click target element.
   */
  function handleRemoveClick(target) {
    const choosedItem = target.closest(choosedItemSelector);
    const checkboxId = choosedItem.getAttribute("data-checkbox-id");
    const checkbox = document.getElementById(checkboxId);

    if (checkbox) checkbox.checked = false;
    choosedItem.remove();
  }

  // Event Delegation
  document.addEventListener("change", (event) => {
    if (event.target.matches(checkboxSelector)) {
      handleCheckboxChange(event.target);
    }
  });

  chosenContainer.addEventListener("click", (event) => {
    if (event.target.closest(removeButtonSelector)) {
      handleRemoveClick(event.target);
    }
  });
}
